import StudyActions from './StudyActions';

export default StudyActions;
